/*=========================================================================================
  File Name: usersActions.js
  Description: Vuex Store - users actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';
import getters from '../getters';

export default {
    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    fetchFirstFrontPageScreen({commit}, payload) {
        let isLoggedIn = !!state.token;
        console.log(11111);
        if(!state.currentTranslations) {
            commit('fetch_first_front_page_screen');
            return new Promise((resolve, reject) => {
                axios({url: state.API_URL + '/auth/active-languages', method: 'GET'}).then((languages) => {

                    let hasValidLocale = false;
                    let locale = '';
                    if (payload.locale !== null) {
                        languages.data.map((lang) => {
                            if (lang.locale === payload.locale) {
                                hasValidLocale = true;
                            }
                        });
                    }

                    if (hasValidLocale) {
                        locale = '/' + payload.locale;
                    }

                    axios.all([
                        axios({url: state.API_URL + '/auth/settings', method: 'GET'}),
                        axios({url: state.API_URL + '/auth/language' + locale, method: 'GET'}),
                        axios({url: state.API_URL + '/auth/countries', method: 'GET'})
                    ]).then(axios.spread((settings, language, countries) => {
                        if (isLoggedIn) {
                            axios({url: state.API_URL + '/auth/user', method: 'GET'})
                                .then((user) => {
                                    let data = {
                                        basicOrganizationData: settings.data.basicOrganizationData,
                                        user: user.data.user,
                                        profile: user.data.profile,
                                        notification_settings: user.data.notification_settings,
                                        profileImage: user.data.profileImage,
                                        profileImage_b: user.data.profileImage_b,
                                        profileImage_s: user.data.profileImage_s,
                                        coverImage: user.data.coverImage,
                                        coverImage_b: user.data.coverImage_b,
                                        coverImage_m: user.data.coverImage_m,
                                        coverImage_s: user.data.coverImage_s,
                                        menus: {
                                            languageMenu: languages.data,
                                        },
                                        activeLanguage: language.data,
                                        countries: countries.data,
                                    };

                                    commit('first_front_page_screen_fetched', data);
                                    resolve();
                                }).catch(() => {
                                commit('fetch_first_front_page_screen_error');
                                reject();
                            });
                        } else {
                            let data = {
                                basicOrganizationData: settings.data.basicOrganizationData,
                                menus: {
                                    languageMenu: languages.data,
                                },
                                activeLanguage: language.data,
                                countries: countries.data,
                            };

                            commit('first_front_page_screen_fetched', data);
                            resolve();
                        }
                    })).catch(() => {
                        commit('fetch_first_front_page_screen_error');
                        reject();
                    });
                }).catch(() => {
                    commit('fetch_first_front_page_screen_error');
                    reject();
                });
            })
        } else {
            if (isLoggedIn) {
                return new Promise((resolve, reject) => {
                    axios({url: state.API_URL + '/auth/user', method: 'GET'})
                        .then((user) => {
                            let data = {
                                user: user.data.user,
                                profile: user.data.profile,
                                notification_settings: user.data.notification_settings,
                                profileImage: user.data.profileImage,
                                profileImage_b: user.data.profileImage_b,
                                profileImage_s: user.data.profileImage_s,
                                coverImage: user.data.coverImage,
                                coverImage_b: user.data.coverImage_b,
                                coverImage_m: user.data.coverImage_m,
                                coverImage_s: user.data.coverImage_s,
                            };

                            commit('first_front_page_screen_fetched', data);
                            resolve();
                        }).catch(() => {
                        commit('fetch_first_front_page_screen_error');
                        reject();
                    });
                });
            }
        }
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    getPage({commit}, payload) {
        return new Promise((resolve, reject) => {

            let q = '';
            let page = '';
            let sort = '';
            if(payload.q != null){
                q = '?q=' + payload.q;
                if(payload.page != null){
                    page = '&page=' + payload.page;
                    if(payload.sort != null) {
                        sort = '&sort=' + payload.sort + '&price_from=' + payload.price_from + '&price_to=' + payload.price_to + '&brands=' + payload.brands;
                    }
                } else {
                    if(payload.sort != null) {
                        sort = '&sort=' + payload.sort + '&price_from=' + payload.price_from + '&price_to=' + payload.price_to + '&brands=' + payload.brands;
                    }
                }
            } else {
                if(payload.page != null){
                    page = '?page=' + payload.page;
                    if(payload.sort != null) {
                        sort = '&sort=' + payload.sort + '&price_from=' + payload.price_from + '&price_to=' + payload.price_to + '&brands=' + payload.brands;
                    }
                } else {
                    if(payload.sort != null) {
                        sort = '?sort=' + payload.sort + '&price_from=' + payload.price_from + '&price_to=' + payload.price_to + '&brands=' + payload.brands;
                    }
                }
            }


            axios({url: state.API_URL + '/auth/page' + q + page + sort, data: payload, method: 'POST'})
                .then(({data}) => {
                    if (!state.user) {
                        localStorage.removeItem('access-token');
                        delete axios.defaults.headers.common['Authorization'];
                    }
                    resolve(data);
                }).catch(() => {
                reject();
            });
        })
    },

    /**
     * Logout
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    logoutFrontend({commit}) {
        return new Promise((resolve) => {
            commit('logout');
            axios({url: state.API_URL + '/auth/logout', method: 'GET'})
                .then(() => {
                    commit('logout_success');
                    localStorage.removeItem('access-token');
                    delete axios.defaults.headers.common['Authorization'];

                    resolve();
                });
        })
    },

    /**
     *
     * @param commit
     * @param lang_id
     * @returns {Promise<unknown>}
     */
    getPages({commit}, lang_id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/front-pages/' + lang_id, method: 'GET'})
                .then(({data}) => {
                    commit('SET_PERMISSIONS', data.permissions);
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @returns {Promise<unknown>}
     */
    createPage({commit}, payload) {
        return new Promise((resolve, reject) => {
            let params = payload.lang_id;
            if(payload.page_id) {
                params = payload.lang_id + '/' + payload.page_id
            }

            axios({url: state.API_URL + '/auth/front-pages/create/' + params, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    storePage({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/front-pages/store', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    editPage({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/front-pages/edit/' + id, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param payload
     * @returns {Promise<unknown>}
     */
    updatePage({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({
                url: state.API_URL + '/auth/front-pages/update/' + payload.id,
                data: payload.data,
                method: 'POST'
            })
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },

    /**
     *
     * @param commit
     * @param id
     * @returns {Promise<unknown>}
     */
    deletePage({commit}, id) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/front-pages/delete/' + id, method: 'DELETE'})
                .then(({data}) => {
                    resolve(data);
                }).catch(({response}) => {
                reject(response.data);
            });
        })
    },
    /**
     *
     * @param payload
     * @returns {Promise<unknown>}
     */
    reorderPages({}, payload) {
        return new Promise(() => {
            axios({url: state.API_URL + '/auth/front-pages/reorder', data: payload, method: 'POST'});
        })
    },
};
